module.exports = __webpack_public_path__ + "static/media/ic-delete.e90d39f4.svg";